module.exports = __webpack_public_path__ + "img/main.bc47b5ad.png";